import React from 'react';
import RenderIf from 'components/RenderIf/RenderIf';
import { useParams } from 'react-router-dom';
import { useGetDealById } from 'views/Deals/hooks/useGetDealById';
import useAuthContext from 'contexts/AuthContext';
import { ProFormaWizardProvider, useProFormaWizard } from './context/ProFormaWizardProvider';
import ProFormaWizardStepper from './components/ProFormaWizardStepper/ProFormaWizardStepper';
import ProFormaWizardStepOne from './components/ProFormaWizardStepOne/ProFormaWizardStepOne';
import ProFormaWizardStepTwo from './components/ProFormaWizardStepTwo/ProFormaWizardStepTwo';
import ProFormaWizardStepThree from './components/ProFormaWizardStepThree/ProFormaWizardStepThree';
import { PRO_FORMA_WIZARD_STEPS } from './constants';

const ProFormaWizardContent = () => {
    const { currentStep } = useProFormaWizard();
    const { dealId } = useParams<{ dealId: string }>();
    const { selectedOrganizationId } = useAuthContext();

    const { data: deal } = useGetDealById({
        orgId: selectedOrganizationId!,
        dealId: Number(dealId),
        shouldFetch: !!Number(dealId),
    });

    return (
        <div>
            <ProFormaWizardStepper />

            <RenderIf isTrue={currentStep === PRO_FORMA_WIZARD_STEPS.STEP_1}>
                <ProFormaWizardStepOne deal={deal} />
            </RenderIf>

            <RenderIf isTrue={currentStep === PRO_FORMA_WIZARD_STEPS.STEP_2}>
                <ProFormaWizardStepTwo deal={deal} />
            </RenderIf>

            <RenderIf isTrue={currentStep === PRO_FORMA_WIZARD_STEPS.STEP_3}>
                <ProFormaWizardStepThree deal={deal} />
            </RenderIf>

        </div>
    );
};

const ProFormaWizard = () => (
    <ProFormaWizardProvider>
        <ProFormaWizardContent />
    </ProFormaWizardProvider>
);

export default ProFormaWizard;
